var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88976 7H1.23886C0.374114 7 -0.0829714 5.97665 0.494128 5.33264L4.49346 0.869618C4.90295 0.412652 5.6236 0.428843 6.01215 0.90374L9.66371 5.36676C10.1979 6.01969 9.73338 7 8.88976 7Z",
    fill: "#2F4858"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretUp);
export default __webpack_public_path__ + "static/media/IconCaretUp.8ff5a1a6.svg";
export { ForwardRef as ReactComponent };